<template>
    <section class="main">
        <div v-show="isLoading">
            <v-page-loading />
        </div>
        <div v-show="!isLoading">
            <v-page-header :title="getPageTile" />

            <div v-show="hasLoadingError">
                <div class="grid-container">
                    <p class="text-center">
                        {{ loadingError }}
                    </p>
                </div>
            </div>

            <div v-show="!hasLoadingError">
                <div class="grid-container">
                    <div class="grid-x">
                        <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                            <div class="wrapper">
                                <v-action-buttons :items="getActionButtons" :isDisabled="pmFormDisabled" @actionClicked="onClickAction" />
                                <v-form-message type="error" id="form-error" :message="pmObjectError" @onClickAction="onClickActivateDialogAction" />
                                <v-form-message type="success" id="form-success" :message="pmObjectSuccess" @onClickAction="onClickActivateDialogAction" />
                                <v-form-message type="default" id="form-activate" :message="pmObjectActivate" :autoCloseTimeout="0" :showActionButtons="true" @onClickAction="onClickActivateDialogAction" />

                                <div class="box">
                                    <v-navigation />

                                    <div class="form-group">
                                        <label for="form-field-salutation">{{ $t('form.account.title') }}</label>
                                        <v-select-salutation id="form-field-salutation" :isStatic="isViewMethod" :placeholder="$t('form.account.title.plc')" v-model="pmObject.profile.salutation" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group form-group--required">
                                        <label>{{ $t('form.account.firstname') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ pmObject.profile.firstname }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group form-group--required" :class="{ 'form-group--error' : $v.pmObject.profile.firstname.$error }">
                                        <label for="form-field-firstname">{{ $t('form.account.firstname') }}</label>
                                        <input type="text" id="form-field-firstname" name="firstname" class="form-control" :placeholder="$t('form.account.firstname.plc')" v-model="$v.pmObject.profile.firstname.$model" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group form-group--required">
                                        <label>{{ $t('form.account.lastname') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ pmObject.profile.lastname }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group form-group--required" :class="{ 'form-group--error' : $v.pmObject.profile.lastname.$error }">
                                        <label for="form-field-lastname">{{ $t('form.account.lastname') }}</label>
                                        <input type="text" id="form-field-lastname" name="lastname" class="form-control" :placeholder="$t('form.account.lastname.plc')" v-model="$v.pmObject.profile.lastname.$model" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group">
                                        <label>{{ $t('form.phone') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ pmObject.profile.communication.phone }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group">
                                        <label for="form-field-phone">{{ $t('form.phone') }}</label>
                                        <input type="text" id="form-field-phone" name="phone" class="form-control" :placeholder="$t('form.phone.plc')" v-model="pmObject.profile.communication.phone" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group">
                                        <label>{{ $t('form.mobile') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ pmObject.profile.communication.mobile }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group">
                                        <label for="form-field-mobile">{{ $t('form.mobile') }}</label>
                                        <input type="text" id="form-field-mobile" name="mobile" class="form-control" :placeholder="$t('form.mobile.plc')" v-model="pmObject.profile.communication.mobile" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group form-group--required">
                                        <label>{{ $t('form.email') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ pmObject.profile.communication.email }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group form-group--required" :class="{ 'form-group--error' : $v.pmObject.profile.communication.email.$error }">
                                        <label for="form-field-email">{{ $t('form.email') }}</label>
                                        <input type="text" id="form-field-email" name="email" class="form-control" :placeholder="$t('form.account.email.plc')" v-model="$v.pmObject.profile.communication.email.$model" />
                                    </div>
                                    <div class="form-group form-group--required" :class="{ 'form-group--error' : $v.pmObject.location_id.$error }">
                                        <label for="form-field-location">{{ $t('form.project.location') }}</label>
                                        <v-select-location id="form-field-location" :customerId="$route.params.customer" :isStatic="isViewMethod" :placeholder="$t('form.project.location.plc')" v-model="$v.pmObject.location_id.$model" />
                                    </div>

                                    <div class="form-group">
                                        <label for="form-field-usertype"> {{ $t('form.account.permissions') }}</label>
                                        <v-select-user-type id="form-field-usertype" :isStatic="isViewMethod" v-model="pmObject.user_type_id" />
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from './../../partials/PageHeader';
    import PageLoading from './../../partials/PageLoading';
    import ActionButtons from './../../partials/Foundation/ActionButtons';
    import Navigation from './../Navigation';
    import FormMessage from './../../partials/Forms/FormMessage';
    import { required, email } from 'vuelidate/lib/validators';

    import SelectSalutation from './../../partials/Forms/SelectSalutation';
    import SelectLocation from './../../partials/Forms/SelectLocation';
    import SelectUserType from './../../partials/Forms/SelectUserType';

    export default {
        data() {
            return {
                loading                 : false,
                loadingError            : null,
                customerObject          : {
                    id                      : 0
                },
                pmFormDisabled          : false,
                pmObjectError           : null,
                pmObjectSuccess         : null,
                pmObjectActivate        : null,
                pmObject                : {
                    id                      : 0,
                    user_type_id            : this.$helpers.usertypes.pm,
                    customer_id             : this.$route.params.customer,
                    location_id             : 0,
                    active                  : 1,
                    profile                 : {
                        firstname               : '',
                        lastname                : '',
                        salutation              : '',
                        gender                  : '',
                        position                : '',
                        address                 : {
                            city                    : '',
                            zipcode                 : '',
                            street                  : '',
                            region                  : '',
                            housenumber             : '',
                            country_code            : 'de'
                        },
                        communication           : {
                            email                   : '',
                            mobile                  : '',
                            phone                   : ''
                        }
                    }
                }
            };
        },
        components : {
            vPageHeader             : PageHeader,
            vPageLoading            : PageLoading,
            vActionButtons          : ActionButtons,
            vNavigation             : Navigation,
            vFormMessage            : FormMessage,
            vSelectSalutation       : SelectSalutation,
            vSelectLocation         : SelectLocation,
            vSelectUserType         : SelectUserType
        },
        computed : {
            isLoading : function () {
                return this.loading;
            },
            hasLoadingError : function () {
                return this.loadingError !== null;
            },
            isViewMethod : function () {
                return this.$route.meta.method === 'view';
            },
            isCreateMethod : function () {
                return this.$route.meta.method === 'create';
            },
            isUpdateMethod : function () {
                return this.$route.meta.method === 'update';
            },
            isDuplicateMethod : function () {
                return this.$route.meta.method === 'duplicate';
            },
            getPageTile : function () {
                if (this.customerObject.company_name) {
                    return this.customerObject.company_name;
                }

                return this.$t('pm.' + this.$route.meta.method + '.title');
            },
            getActionButtons : function () {
                let buttons = [];

                if (this.isViewMethod) {
                    if (this.$store.getters.userHasPermission('pm_update')) {
                        buttons.push({
                            action : 'update',
                            router  : { name : 'customers-update-customer-pm', params : { custumor : this.$route.params.customer, account : this.$route.params.account } }
                        });
                    }
                }

                if (this.isCreateMethod) {
                    if (this.$store.getters.userHasPermission('pm_create')) {
                        buttons.push({
                            action : 'save'
                        });
                    }
                }

                if (this.isUpdateMethod) {
                    if (this.$store.getters.userHasPermission('pm_update')) {
                        buttons.push({
                            action : 'save'
                        });
                    }

                    if (parseInt(this.pmObject.id) !== parseInt(this.$store.getters.getUser.id)) {
                        if (this.$store.getters.userHasPermission('pm_activate')) {
                            if (this.pmObject.active) {
                                buttons.push({
                                    action : 'deactivate'
                                });
                            } else {
                                buttons.push({
                                    action : 'activate'
                                });
                            }
                        }
                    }
                }

                buttons.push({
                    action  : 'cancel',
                    router  : { name : 'customers-view-customer-pms', params : { customer : this.$route.params.customer } }
                });

                return buttons;
            }
        },
        watch : {
            '$route' : {
                handler : function () {
                    this.onUpdateCustomer();
                },
                deep    : true
            }
        },
        created : function () {
            this.onUpdateCustomer();
        },
        validations : function () {
            return {
                pmObject : {
                    location_id : {
                        required,
                        isValidNumber : (value) => {
                            return parseInt(value) !== NaN && parseInt(value) >= 1;
                        }
                    },
                    profile : {
                        firstname : {
                            required
                        },
                        lastname : {
                            required
                        },
                        communication : {
                            email : {
                                required,
                                email
                            }
                        }
                    }
                }
            }
        },
        methods : {
            onUpdateCustomer : function() {
                this.customerLoadingError = null;

                if (!this.$route.params.customer) {
                    this.onUpdatePmObject();
                } else {
                    let promise = this.$api.clearParams()
                        .get('customers/' + this.$route.params.customer + '/get');

                    promise.then((response => {
                        this.customerObject = response.data.data;

                        this.onUpdatePmObject();
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.loading = false;
                    }).bind(this));

                    this.loading = true;
                }
            },
            onUpdatePmObject : function () {
                this.loadingError = null;

                if (!this.isCreateMethod) {
                    let promise = this.$api.clearParams()
                        .get('accounts/' + this.$route.params.account + '/get');

                    promise.then((response => {
                        this.pmObject = response.data.data;
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.loading = false;
                    }).bind(this));

                    this.loading = true;
                }
            },
            onSubmitPmObject : function () {
                this.pmFormDisabled     = true;
                this.pmObjectError      = null;
                this.pmObjectSuccess    = null;

                this.$v.pmObject.$touch();

                if (this.$v.pmObject.$invalid) {
                    this.pmFormDisabled     = false;
                    this.pmObjectError      = this.$t('form.error_form');
                } else {
                    if (this.isCreateMethod) {
                        let promise = this.$api.clearParams()
                            .post('accounts/create', this.pmObject);

                        promise.then((response => {
                            this.pmFormDisabled     = false;
                            this.pmObjectSuccess    = this.$t('pm.create.success');

                            this.$router.push({ name : 'customers-update-customer-pm', params : { customer : this.$route.params.customer, account : response.data.data.id } })
                        }).bind(this)).catch((error => {
                            this.pmFormDisabled     = false;
                            this.pmObjectError      = error.response.data.message;
                        }).bind(this));
                    } else if (this.isUpdateMethod) {
                        let promise = this.$api.clearParams()
                            .post('accounts/' + this.$route.params.account + '/update', this.pmObject);

                        promise.then((response => {
                            this.pmFormDisabled     = false;
                            this.pmObjectSuccess    = this.$t('pm.update.success');
                        }).bind(this)).catch((error => {
                            this.pmFormDisabled     = false;
                            this.pmObjectError      = error.response.data.message;
                        }).bind(this));
                    }
                }
            },
            onActivatePmObject : function () {
                if (!this.pmObject.active) {
                    this.pmObjectActivate = this.$t('pm.active.title');
                } else {
                    this.pmObjectActivate = this.$t('pm.deactive.title');
                }
            },
            onActivatePmObjectSubmit : function () {
                this.pmFormDisabled     = true;
                this.pmObjectError      = null;
                this.pmObjectSuccess    = null;
                this.pmObjectActivate   = null;

                let promise = this.$api.clearParams()
                    .post('accounts/' + this.$route.params.account + '/activate', {
                        active : !this.pmObject.active
                    });

                promise.then((response => {
                    this.pmFormDisabled = false;

                    if (response.data.data.active) {
                        this.pmObjectSuccess = this.$t('pm.active.success');
                    } else {
                        this.pmObjectSuccess = this.$t('pm.deactive.success');
                    }

                    this.pmObject.active    = response.data.data.active;
                }).bind(this)).catch((error => {
                    this.pmFormDisabled     = false;
                    this.pmObjectError      = error.response.data.message;
                }).bind(this));
            },
            onClickAction : function (action) {
                this.pmObjectError      = null;
                this.pmObjectSuccess    = null;
                this.pmObjectActivate   = null;

                switch (action) {
                    case 'save':
                        this.onSubmitPmObject();

                        break;
                    case 'activate':
                    case 'deactivate':
                        this.onActivatePmObject();

                        break;
                }
            },
            onClickActivateDialogAction : function (id, action) {
                this.pmObjectError      = null;
                this.pmObjectSuccess    = null;
                this.pmObjectActivate   = null;

                switch (action) {
                    case 'yes':
                        if (id === 'form-activate') {
                            this.onActivatePmObjectSubmit();
                        }

                        break;
                }
            }
        }
    }
</script>